// -----------------  SET IS PIP AVAILABLE -----------------
export const SET_IS_PIP_AVAILABLE = 'SET_IS_PIP_AVAILABLE';

// -----------------  SET IS PIP ON -----------------
export const SET_IS_PIP_ON = 'SET_IS_PIP_ON';
